import styled from "styled-components";
import { theme } from '../../theme'


export const ContentWrapper = styled.div`
    background-color: ${theme.colors.grey03};
    height: 100%;
`
export const Container = styled.div`
    margin: 0 auto;
    padding: 4rem 1rem;
    max-width: 730px;
`
export const MainContent = styled.div`
    padding: 0px 10px;
`

export const Heading = styled.div`
    color: ${theme.colors.mainBlue};
    font-weight: 700;
    font-size: 3rem;
`
export const OverviewSection = styled.div`
    margin-top: 2.7rem;
`
export const ModuleHeader = styled.div`
    display: flex;
    align-items:center;
    margin-bottom: 20px;

    span {
        font-weight: 700;
        font-size: 1.2rem;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: ${theme.colors.black};
        margin-right: 5px;
    }
`
export const Hr = styled.hr`
    height: 1px;
    background-color:rgb(216 216 216 / 37%);
    flex: 1;
    border: none;
`
export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(31.8rem, 1fr));
    grid-column-gap: 1.3rem;
    margin-top: 2.7rem;

    @media only screen and (max-width: 768px) {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        row-gap: 20px;
        width: 100%;
     }
`
export const ExamAndSubjectContainer = styled.div`
    margin-top: 3rem;
`
export const AnnouncementContainer = styled.div`
    margin-top: 3rem;
`
export const AdminDashboardCountGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    grid-column-gap: 2.082rem;
    grid-row-gap: 2.082rem;
`
export const AdminDashboardCountGridItem = styled.div`
    background-color: ${({ active }) => (active ? '#58B7C2' : '#FFFFFF')};
    color: ${({ active }) => (active ? '#FFFFFF' : '#3B3B42')};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 11px;
    text-align: center;
    font-weight: 700;
    padding: 1.67rem 0 1.3rem 0;

    .title {
        font-size: 1.7rem;   
    }

    .count {
        font-size: 4.3rem;
    }
`